import React, { useState, useEffect, useCallback } from 'react';
import { Typography, Dialog, Box, Fab, Tooltip, Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import 'react-phone-number-input/style.css';
import EmployeeStatusCardComponent from './EmployeeStatusCardComponent';
import Select from 'react-select';
import GenericLoader from '../../components/Loader/GenericLoader';
import DeletableChips from '../../components/Chip/DeletableChip';
import Card from '@mui/material/Card';
import './EmployeeOnboarding.css';
import AddIcon from '@mui/icons-material/Add';
import KeycloakService from '../../services/KeycloakService';
import {
  getAllEmployees,
  getAllEmployeesByName,
} from '../../services/EmployeeService';
import { useDispatch } from 'react-redux';
import PaginationComponent from '../../components/Pagination/Pagination';
import EditCard from './EditCard';
import { WFHAttribute, SHOW_NOTIFICATION } from '../../constants';
import {
  getDesignations,
  getOfficeLocations,
  getLeaveGroups,
} from '../../admin/Services/MasterdataService';
import { getEligibleReportingManagers } from '../../admin/Services/EmployeeMasterCsvService';

const EmployeeOnboarding = (props) => {
  const { selectedStatus, orgEmailData, clearProps } = props;
  const [employeeDetails, setEmployeeDetails] = useState({
    applierId: KeycloakService.getUserDetail(),
    employeeCode: '',
    firstName: '',
    lastName: '',
    designation: '',
    dateOfBirth: '',
    status: 'PENDING',
    phoneNumber: '',
    personalEmailId: '',
    dateOfJoining: null,
    organizationEmailId: null,
    usageLocation: '',
    jobType: '',
    locationId: null,
    locationName: '',
    leaveGroupId: null,
    reportingManagerId: null,
  });
  const [isAddButton, setIsAddButton] = useState(true);
  const [isHr, setIsHr] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPage] = useState();
  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(1);
  const [pageNo, setPageNo] = useState(0);
  const [refreshPage, setRefreshPage] = useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [files, setFiles] = React.useState(null);
  const [loader, setLoader] = useState(false);
  const [users, setUsers] = useState([]);
  const [uploadedPhoto, setUploadedPhoto] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showErrorMessageDob, setShowErrorMessageDob] = useState(false);
  const [showErrorMessageDoj, setShowErrorMessageDoj] = useState(false);
  const [showErrorMessageDoi, setShowErrorMessageDoi] = useState(false);
  const [showErrorMessagePEmail, setShowErrorMessagePEmail] = useState(false);
  const [showErrorMessageOEmail, setShowErrorMessageOEmail] = useState(false);
  const [showErrorMessagePhoneNo, setShowErrorMessagePhoneNo] = useState(false);
  const [isLastActionFocus, setIsLastActionFocus] = useState(false);
  const [selected, setSelected] = useState('');

  const [allEmpDetails, setAllEmpDetails] = useState([]);

  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState(false);
  const [designationNames, setDesignationNames] = useState([]);
  const [officeLocations, setOfficeLocations] = useState([]);
  const [leaveGroups, setLeaveGroups] = useState([]);
  const [reportingManagers, setReportingManagers] = useState([]);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    if (selected.length === 0) setIsFocused(false);
  };
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  var designationData;
  var officeLocationData;

  const getAllDesignation = async () => {
    designationData = await getDesignations();

    const newDesignationNames = designationData.data.data.map(
      (data) => data.designationNames[0],
    );
    setDesignationNames(newDesignationNames);
  };
  const getAllOfficeLocations = async () => {
    officeLocationData = await getOfficeLocations();
    setOfficeLocations(officeLocationData?.data?.data);
  };
  const getAllLeaveGroups = async () => {
    const leaveGroupData = await getLeaveGroups();
    setLeaveGroups(leaveGroupData?.data?.data || []);
  };
  const getAllReportingManagers = async () => {
    const response = await getEligibleReportingManagers();
    setReportingManagers(response?.data?.data || []);
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  let eName = undefined;
  let status = undefined;

  const getEmployees = async (searchString, pageSize) => {
    if (searchString.length >= 2) {
      setIsLoading(true);
      const employeeList = await getAllEmployees(
        pageSize,
        pageNo,
        '',
        selectedStatus.value,
        '',
        searchString,
      );
      if (employeeList.isError === false) {
        setAllEmpDetails((prev) => []);
        setAllEmpDetails(employeeList.data.data.content);
        setTotalPage(employeeList.data.data.totalPages);
        if (employeeList?.data?.numberOfElements === 0) {
          setPageNo(0);
          setPage(1);
        }
        setIsLoading(false);
      }
      dipatchNotification(employeeList.type, employeeList.message);
    } else {
      setIsLoading(false);
    }
  };
  const searchEmployeeByName = useCallback(debounce(getEmployees), []);

  const handleToggle = async (selectedOption) => {
    // setIsLastActionFocus(true);

    if (selectedOption === orgEmailData?.status) {
      const employeeListByStatus = await getAllEmployees(
        pageSize,
        pageNo,
        eName,
        selectedOption,
        orgEmailData.orgEmail,
      );
      dipatchNotification(
        employeeListByStatus.type,
        employeeListByStatus.message,
      );
      if (employeeListByStatus?.status === 200) {
        setTotalPage(employeeListByStatus.data.data.totalPages);
        setAllEmpDetails([...employeeListByStatus.data.data.content]);

        if (employeeListByStatus?.data?.numberOfElements === 0) {
          setPageNo(0);
          setPage(1);
        }
      } else {
        if (employeeListByStatus?.status !== 200) {
          dipatchNotification(
            employeeListByStatus.type,
            employeeListByStatus.message,
          );
        }
        if (
          employeeListByStatus?.status === 200 &&
          !employeeListByStatus.data.data.totalPages
        ) {
          dipatchNotification(
            employeeListByStatus.type,
            'Total Pages Data Not Found',
          );
        }
      }
    } else {
      const employeeListByStatus = await getAllEmployees(
        pageSize,
        pageNo,
        eName,
        selectedOption,
      );
      dipatchNotification(
        employeeListByStatus.type,
        employeeListByStatus.message,
      );
      if (employeeListByStatus?.status === 200) {
        setTotalPage(employeeListByStatus.data.data.totalPages);
        setAllEmpDetails([...employeeListByStatus.data.data.content]);

        if (employeeListByStatus?.data?.numberOfElements === 0) {
          setPageNo(0);
          setPage(1);
        }
      } else {
        if (employeeListByStatus?.status !== 200) {
          dipatchNotification(
            employeeListByStatus.type,
            employeeListByStatus.message,
          );
        }
        if (
          employeeListByStatus?.status === 200 &&
          !employeeListByStatus.data.data.totalPages
        ) {
          dipatchNotification(
            employeeListByStatus.type,
            'Total Pages Data Not Found',
          );
        }
      }
    }
  };

  const handlePageSizeChange = async (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    pageChange(null, 1);
  };

  const allEmployeesDetails = async (eName) => {
    setLoader(true);

    try {
      const allEmployees = await getAllEmployees(
        pageSize,
        pageNo,
        eName,
        status,
      );
      if (!allEmployees.data) {
        setLoader(false);
        return;
      }
      setTotalPage(allEmployees.data.data.totalPages);
      setAllEmpDetails((prevProjects) => [...allEmployees.data.data.content]);
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };
  useEffect(() => {
    getEmployees(selected, pageSize);
    if (selected.length <= 1) {
      handleToggle(selectedStatus.value);
    }
  }, [refreshPage, orgEmailData]);

  useEffect(() => {
    getAllDesignation();
    getAllOfficeLocations();
    getAllLeaveGroups();
    getAllReportingManagers();
  }, []);

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setRefreshPage(!refreshPage);
  };

  const handleDeleteChip = () => {
    clearProps();
    window.history.pushState(null, '', '/hr-employee-onboarding');
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleOpen = () => {
    setLoader(true);
    setUploadedPhoto('');
    setEmployeeDetails({
      applierId: KeycloakService.getUserDetail(),
      employeeCode: null,
      firstName: '',
      lastName: '',
      designation: '',
      dateOfBirth: null,
      status: 'PENDING',
      phoneNumber: '',
      personalEmailId: '',
      dateOfJoining: new Date().toUTCString(),
      dateOfInternship: new Date().toUTCString(),
      organizationEmailId: '',
      usageLocation: '',
      jobType: '',
      locationId: null,
      locationName: '',
    });

    setFiles(null);

    setShowErrorMessage(false);
    setShowErrorMessageDob(false);
    setShowErrorMessageDoj(false);
    setShowErrorMessageDoi(false);
    setShowErrorMessageOEmail(false);
    setShowErrorMessagePEmail(false);
    setShowErrorMessagePhoneNo(false);
    setLoader(false);
    setOpenModal(true);
  };

  return (
    <div style={{ width: '100%', height: '10%' }}>
      <div style={{ width: '100%', height: '100%' }}>
        {loader ? (
          <div>
            <GenericLoader rectAttributes={WFHAttribute} />
          </div>
        ) : (
          <div>
            <div
              style={{
                display: 'flex',
                paddingBottom: '2rem',
                justifyContent: 'space-between',
                marginRight: '1rem',
                marginLeft: '2rem',
              }}
            >
              <Box width="30%">
                {selectedStatus.value !== orgEmailData.status ? (
                  <TextField
                    className="search-select2"
                    label="Employee Name / ID"
                    name="color"
                    onChange={(e) => {
                      const inputText = e.target.value;
                      if (inputText !== '') {
                        if (inputText.length >= 2) {
                          setPage(1);
                          setPageNo(0);
                          searchEmployeeByName(inputText, pageSize);
                        }
                        setSelected(inputText);
                      } else {
                        setSelected('');
                        pageChange(null, 1);
                      }
                    }}
                    value={isLastActionFocus ? '' : selected}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    InputLabelProps={
                      !isFocused
                        ? {
                            sx: {
                              transform: 'translate(10%, 25%)',
                            },
                          }
                        : {}
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      sx: {
                        '& input': {
                          height: '5px',
                        },
                      },
                    }}
                  />
                ) : null}
                {selectedStatus.value === orgEmailData.status ? (
                  <DeletableChips
                    chipValue={orgEmailData.orgEmail}
                    chipKey={1}
                    deleteChip={handleDeleteChip}
                  />
                ) : null}
              </Box>
            </div>

            {allEmpDetails.length !== 0 ? (
              <EmployeeStatusCardComponent
                designationNames={designationNames}
                officeLocations={officeLocations}
                leaveGroups={leaveGroups}
                reportingManagers={reportingManagers}
                isHr={isHr}
                Files={1}
                handleToggle={handleToggle}
                selectedStatus={selectedStatus}
                allEmployeesDetails={allEmployeesDetails}
                allEmpDetails={allEmpDetails}
                EmployeeDetails={employeeDetails}
                ShowErrorMessage={showErrorMessage}
                ShowErrorMessageDob={showErrorMessageDob}
                ShowErrorMessageDoj={showErrorMessageDoj}
                ShowErrorMessageDoi={showErrorMessageDoi}
                ShowErrorMessageOEmail={showErrorMessageOEmail}
                ShowErrorMessagePEmail={showErrorMessagePEmail}
                ShowErrorMessagePhoneNo={showErrorMessagePhoneNo}
              />
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '60vh',
                }}
              >
                <div>
                  <Typography>{'No Employee Requests..'}</Typography>
                </div>
              </div>
            )}
            {allEmpDetails.length ? (
              <Box className="page-holder">
                <PaginationComponent
                  count={totalPage}
                  page={page}
                  pageChange={pageChange}
                  pageSize={pageSize}
                  handlePageSizeChange={handlePageSizeChange}
                />
              </Box>
            ) : (
              <></>
            )}

            <Box>
              <Tooltip
                title={
                  <Typography sx={{ fontSize: '0.8rem' }}>
                    Add Employee
                  </Typography>
                }
                placement="top"
              >
                <Fab
                  color="primary"
                  style={{
                    right: 30,
                    bottom: 50,
                    position: 'fixed',
                  }}
                  onClick={() => {
                    handleOpen();
                  }}
                >
                  <AddIcon />
                </Fab>
              </Tooltip>
            </Box>

            <Dialog
              open={openModal}
              fullWidth
              maxWidth="md"
              onClose={handleClose}
              PaperProps={{
                sx: { maxHeight: '90vh', overflowY: 'auto' },
              }}
            >
              <Card
                variant="outlined"
                style={{ marginTop: '-1.2rem', overflow: 'visible' }}
              >
                <EditCard
                  designationNames={designationNames}
                  officeLocations={officeLocations}
                  leaveGroups={leaveGroups}
                  reportingManagers={reportingManagers}
                  handleToggle={handleToggle}
                  selectedStatus={selectedStatus}
                  allEmployeesDetails={allEmployeesDetails}
                  isAddButton={isAddButton}
                  updatedUploadedPhoto={uploadedPhoto}
                  updatedFiles={files}
                  updatedEmployeeDetails={employeeDetails}
                  updatedShowErrorMessageDob={showErrorMessageDob}
                  updatedShowErrorMessageDoj={showErrorMessageDoj}
                  updatedShowErrorMessageDoi={showErrorMessageDoi}
                  updatedShowErrorMessageOEmail={showErrorMessageOEmail}
                  updatedShowErrorMessagePEmail={showErrorMessagePEmail}
                  updatedShowErrorMessagePhoneNo={showErrorMessagePhoneNo}
                  open={openModal}
                  setOpen={setOpenModal}
                  handleClose={handleClose}
                  handleOpen={handleOpen}
                />
              </Card>
            </Dialog>
          </div>
        )}
      </div>
    </div>
  );
};
export default EmployeeOnboarding;
